import React from "react";
import './portfolio.scss';
import { Link } from "react-router-dom";
import Card from "./card";
import LogoCarousel from "./LogoCarousel";

const PortfolioPreview: React.FC = () => {
  return (
    <>
      <section className="portfolio container" id="portfolio-section">
        <div className="wrapper">
          
          <h1>Portfolio projects</h1>
          <div className="description">
            <span>Every project is like a new little story: </span>
            <br></br>
            <span>Unique starting points and tasks, but all with a happy end.</span>
          </div>
          <div className="card-container">
            <Card size="medium" title="Soilcast" subtitle="A Smart Irrigation System" link={"/soilcast"}/>
            <Card size="small" title="BeCharge + Plenitude" subtitle="Placing new charging hubs around Europe" link={"/becharge"}/>
          </div>
          <div className="cta-container">

            <Link to="/portfolio" className="cta">
              View my projects
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 185.343 185.343"
                className="ml-2 w-5 h-5 inline-block"
                fill="currentColor"
              >
                <g>
                  <g>
                    <path d="M51.707,185.343c-2.741,0-5.493-1.044-7.593-3.149c-4.194-4.194-4.194-10.981,0-15.175    
                      l74.352-74.347L44.114,18.32c-4.194-4.194-4.194-10.987,0-15.175c4.194-4.194,10.987-4.194,15.18,0l81.934,81.934    
                      c4.194,4.194,4.194,10.987,0,15.175l-81.934,81.939C57.201,184.293,54.454,185.343,51.707,185.343z"
                    />
                  </g>
                </g>
              </svg>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default PortfolioPreview;